<template>
  <footer class="global-footer">
    <div class="footer-container">
      <div class="footer-gradient-bar"></div>

      <div class="footer-grid">
        <!-- 公司信息 -->
        <div class="footer-section">
          <h3 class="section-title">Chuan Yan</h3>
          <div class="contact-info">
            <div class="contact-item">
              <MapPinIcon/>
              <span>No. 301 Xiahe Road, Siming District, Xiamen
              </span>
            </div>
            <div class="contact-item">
              <PhoneIcon/>
              <span>+86 18159684046</span>
            </div>
            <div class="contact-item">
              <EnvelopeIcon/>
              <span>chen@chuanyan.net</span>
            </div>
            <div class="contact-item">
              <ClockIcon/>
              <span>Weekdays 09:00-17:30 (GMT+8)</span>
            </div>
          </div>
        </div>

        <div class="footer-section">
          <h3 class="section-title">Products</h3>
          <div class="link-group">
            <div
                v-for="link in quickLinks"
                :key="link.path"
                class="footer-link"
                @click="goProducts(link.category)"
            >
              {{ link.name }}
            </div>
          </div>
        </div>

        <div class="footer-section">
          <h3 class="section-title">Info</h3>
          <div class="cert-links">
            <div
                v-for="link in companyList"
                :key="link.path"
                class="cert-link"
                @click="navigateTo(link.path)"
            >
              {{ link.name }}
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 16px">
        <a style="color: #ffffff;opacity: 0.7;cursor: pointer;font-size: 14px" href="http://beian.miit.gov.cn">闽ICP备2025090488号</a>
        <br>
        <a style="color: #ffffff;opacity: 0.7;cursor: pointer;font-size: 14px" href="https://beian.mps.gov.cn/#/query/webSearch">闽公网安备35060102000077号</a>
      </div>
      <!-- 底部信息 -->
      <!--      <div class="footer-bottom">-->
      <!--        <div class="social-links">-->
      <!--          <a-->
      <!--              v-for="social in socialPlatforms"-->
      <!--              :key="social.name"-->
      <!--              :href="social.url"-->
      <!--              class="social-icon"-->
      <!--          >-->
      <!--          </a>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </footer>
</template>

<script>
import {
  MapPinIcon,
  PhoneIcon,
  ClockIcon,
  EnvelopeIcon
} from '@heroicons/vue/24/outline';

export default {
  name: "FooterView",
  components: {
    MapPinIcon,
    PhoneIcon,
    ClockIcon,
    EnvelopeIcon
  },
  data() {
    return {
      quickLinks: [
        { path: "/products", name: "O Rings", category: 1 },
        { path: "/products", name: "Oli Seal", category: 2 },
        { path: "/products", name: "X Rings", category: 3 },
        { path: "/products", name: "O Ring Kits", category: 4 },
        // { path: "/products", name: "NBR O Rings" },
        { path: "/products", name: "Mechanical Seals", category: 9 },
        { path: "/products", name: "Metal Washer", category: 7 },
        { path: "/products", name: "Custom Rubber Parts", category: 8 },
        { path: "/products", name: "Back Up Ring", category: 6 },
      ],
      socialPlatforms: [],
      companyList: [
        { name: 'Contact Us', path: '/contact' },
        { name: 'About Us', path: '/about' },
        { name: 'News', path: '/news' },
        { name: 'Privacy Policy' },
      ],
    };
  },
  methods: {
    navigateTo(path, params = {}) {
        if (!path) return;
      this.$navigate.path(path, {
        query: params.query,
        params: params.params
      });
    },
    goProducts(categoryId) {
      if (
          this.$route.name === 'ProductsView' &&
          this.$route.query.category === categoryId
      ) {
        return; // 不跳转
      }
      // 否则执行跳转
      this.$router.push({
        path: '/products',
        query: { category: categoryId }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.global-footer {
  background: #0a1a2f;
  color: rgba(255, 255, 255, 0.8);
  padding: 32px 0 32px;
  position: relative; /* 新增 */
  margin-top: 80px; /* 新增间距 */
}

/* 新增渐变分隔线样式 */
.global-footer::before {
  content: '';
  position: absolute;
  top: -80px;
  left: 0;
  width: 100%;
  height: 60px;
  background: linear-gradient(
          to bottom,
          rgba(18, 36, 61, 0) 0%,
          rgba(18, 36, 61, 1) 100%
  );
  pointer-events: none;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  padding-bottom: 48px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}

.section-title {
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #c5a47e;
  position: relative;
}

.section-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 60px;
  height: 2px;
  background: #c5a47e;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  line-height: 1.6;
}

.contact-item svg {
  height: 20px;
  width: 20px;
  margin-right: 4px;
  color: #C5A47E;
}

.contact-item i {
  color: #c5a47e;
  font-size: 18px;
}

.contact-item a {
  color: inherit;
  transition: color 0.3s ease;
}

.contact-item a:hover {
  color: #c5a47e;
}

/* 调整产品链接布局 */
.link-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
}

.certification {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.cert-image {
  height: 80px;
  width: auto;
}

.cert-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cert-links a {
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s ease;
}

.cert-links a:hover {
  color: #c5a47e;
}

.footer-bottom {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.social-links {
  display: flex;
  gap: 24px;
}

.social-icon {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s ease;
}

.social-icon:hover {
  color: #c5a47e;
}

.copyright {
  text-align: right;
  font-size: 14px;
  line-height: 1.6;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }

  .copyright {
    text-align: center;
  }
}

.footer-link,
.cert-link {
  position: relative;
  padding: 3px 0;
  display: inline-block;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
  text-decoration 0.3s cubic-bezier(0.4, 0, 0.2, 1); /* 新增过渡 */
}

.footer-link:hover,
.cert-link:hover {
  color: #c5a47e;
  text-decoration: underline;
  text-decoration-color: #c5a47e;
}
</style>
